import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Planning Your Trip"
      meta={[
        {
          name: 'description',
          content: 'Planning your trip to Fire Island',
        },
        {
          name: 'keywords',
          content: 'Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className="container page">
      <div className="heading text-center mb-5 mt-3">
        <h1>
          <i className="far fa-clipboard-list" /> Planning Your Trip
        </h1>
        <p>
          Fire Island is open and waiting for us to bring you there! Before your
          arrival, we kindly ask that you review the following Travel Tips &
          Information to prepare for the journey with us.
        </p>
      </div>
      <TipItem>
        <h3>Budget Extra Time</h3>
        <p>
          Save yourself the headache and build in extra time to park, unload
          your luggage, purchase your tickets, and get settled before boarding
          the ferry to Fire Island.
        </p>
      </TipItem>
      <TipItem>
        <h3>Leave The Car Behind</h3>
        <p>
          With the increased traffic to Fire Island during the summer season,
          parking is extremely limited. If possible, it is highly recommended to
          take public transportation or an Uber. With our latest Uber
          integration, you can purchase your ferry tickets within the Uber app.
        </p>
      </TipItem>
      <TipItem>
        <h3>Skip the Lines</h3>
        <p>
          Save time & download the Ferry Ticket App (FI mTickets) to
          pre-purchase your tickets and bypass the ticket line.
        </p>
      </TipItem>
      <TipItem>
        <h3>Looking to avoid the crowds? Moving In?</h3>
        <p>
          Water Taxi Crossbay service is available to take you from Bay Shore to
          your Fire Island destination. If moving in, water taxi move in
          packages are available to get you and your belongings to Fire Island
          on your time. Call them at 631.665.8885 or visit
          <a href="https://www.fireislandwatertaxi.com">
            Fire Island Water Taxi
          </a>{' '}
          to inquire about the Cross-Bay service.
        </p>
      </TipItem>
      <TipItem>
        <h3>Pack Smart</h3>
        <p>
          Our Luggage Policy has recently been updated to better serve the
          communities and to protect our passengers and staff. Find out what you
          can bring with you on the ferry and what needs to go on the freight
          boat by <Link to="/info/passenger-freight/">clicking here</Link>.
        </p>
        <p>
          If your luggage surpasses the per-person limitation, or you are
          bringing over non-essential items, you may have to bring it over to
          the freight house by the Main Terminal. This could add time to your
          travel so plan accordingly.
        </p>
      </TipItem>
      <TipItem>
        <h3>Stay Updated</h3>
        <p>
          At the bottom of the page you can sign up for email alerts about
          service changes, new schedules, and more. Also, follow our social
          media accounts on Instagram (
          <a href="https://www.instagram.com/fiferries/">@fiferries</a>) &
          Facebook (
          <a href="https://www.facebook.com/FIFerries/">Fire Island Ferries</a>)
          to get the latest on business openings, new updates, and more. Help us
          & support local businesses!
        </p>
      </TipItem>
    </div>
  </div>
);

const TipItem = ({ children }) => <div className="tip-item">{children}</div>;
